<template>
  <div class="notice-wrapper">
    <b class="notice-title">{{ $t('labels.cancelFeeGuide') }}</b>

    <ul class="notice-list">
      <li>
        <div class="bold">[{{ $t('cancelNotice.ticket.general') }}]</div>
      </li>
      <li>
        <span class="check-icon"><CheckBold :size="13" /></span>
        {{ $t('cancelNotice.cruisePolicy.before3Days') }}
      </li>
      <li>
        <span class="check-icon"><CheckBold :size="13" /></span>
        {{ $t('cancelNotice.cruisePolicy.before2Days') }}
      </li>
      <li>
        <span class="check-icon"><CheckBold :size="13" /></span>
        {{ $t('cancelNotice.cruisePolicy.before1Days') }}
      </li>
      <li>
        <span class="check-icon"><CheckBold :size="13" /></span>
        {{ $t('cancelNotice.cruisePolicy.before2Hours') }}
      </li>
      <li>
        <span class="check-icon"><CheckBold :size="13" /></span>
        {{ $t('cancelNotice.cruisePolicy.after2Hours') }}
      </li>
      <li>
        <span class="popup">*</span>
        {{ $t('cancelNotice.cruisePolicy.changeDateFee') }}
      </li>

      <br />

      <template v-if="!isJapanesePayment">
        <li>
          <div class="bold">[{{ $t('cancelNotice.ticket.discount') }}]</div>
        </li>
        <li>
          <span class="check-icon"><CheckBold :size="13" /></span>
          {{ $t('cancelNotice.discountPolicy.before7Days') }}
        </li>
        <li>
          <span class="check-icon"><CheckBold :size="13" /></span>
          {{ $t('cancelNotice.discountPolicy.before1Days') }}
        </li>
        <li>
          <span class="check-icon"><CheckBold :size="13" /></span>
          {{ $t('cancelNotice.discountPolicy.before0Days') }}
        </li>
        <li>
          <span class="popup">*</span>
          {{ $t('cancelNotice.discountPolicy.changeDateFee') }}
        </li>
        <br />
      </template>

      <li>
        <div class="bold">[{{ $t('cancelNotice.ticket.meal') }}]</div>
      </li>
      <li>
        <span class="check-icon"><CheckBold :size="13" /></span>
        {{ $t('cancelNotice.mealPolicy.before1Days') }}
      </li>
      <li>
        <span class="check-icon"><CheckBold :size="13" /></span>
        {{ $t('cancelNotice.mealPolicy.before0Days') }}
      </li>

      <br />

      <template v-if="!isJapanesePayment">
        <li>
          <div class="bold">[{{ $t('cancelNotice.ticket.oneNight') }}]</div>
        </li>
        <li>
          <span class="check-icon"><CheckBold :size="13" /></span>
          {{ $t('cancelNotice.oneNightPolicy.before15Days') }}
        </li>
        <li>
          <span class="check-icon"><CheckBold :size="13" /></span>
          {{ $t('cancelNotice.oneNightPolicy.before10Days') }}
        </li>
        <li>
          <span class="check-icon"><CheckBold :size="13" /></span>
          {{ $t('cancelNotice.oneNightPolicy.before7Days') }}
        </li>
        <li>
          <span class="check-icon"><CheckBold :size="13" /></span>

          {{ $t('cancelNotice.oneNightPolicy.before2Days') }}
        </li>
        <li>
          <span class="check-icon"><CheckBold :size="13" /></span>
          {{ $t('cancelNotice.oneNightPolicy.before0Days') }}
        </li>
        <li>
          <span class="popup">*</span>
          {{ $t('cancelNotice.oneNightPolicy.changeDateFee') }}
        </li>
        <li>
          <span class="popup">*</span>
          {{ $t('cancelNotice.oneNightPolicy.changePassengerFee') }}
        </li>
        <br />
      </template>

      <li class="seperate-terms">
        <div class="term">
          <span class="popup">※</span>
          {{ $t('cancelNotice.feeAppliedFare') }}
        </div>
        <div v-if="!isJapanesePayment" class="term">
          <span class="popup">※</span>
          {{ $t('cancelNotice.standardTicketRefund') }}
        </div>
        <div v-if="!isJapanesePayment" class="term">
          <span class="popup">※</span>
          {{ $t('cancelNotice.changePassengerFee') }}
        </div>
        <div class="term">
          <span class="popup">※</span>
          {{ $t('cancelNotice.cancelInquiry') }}
        </div>
        <br />

        <div v-if="!isJapanesePayment" class="bold pw">
          <template v-if="locale !== 'ja'">
            {{ $t('cancelNotice.customerCenter', { email: locale === 'en' ? 'cruise@panstar.kr' : '' }) }}
          </template>
          <template v-else>
            {{ $t('cancelNotice.customerCenter.tsushima') }}
            <br />{{ $t('cancelNotice.customerCenter.osaka') }}
          </template>
        </div>

        <div v-else class="bold pw">
          <template v-if="locale !== 'ja'">
            {{ $t('cancelNotice.customerCenter', { email: locale === 'en' ? 'cruise@panstar.kr' : '' }) }}
          </template>
          <template v-else>
            {{ $t('cancelNotice.customerCenter.tsushima') }}
            <br />{{ $t('cancelNotice.customerCenter.osaka') }}
          </template>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import CheckBold from 'vue-material-design-icons/CheckBold';

export default {
  name: 'CancelNotice',
  components: { CheckBold },
  props: {
    paymentLocale: String,
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    isJapanesePayment() {
      return this.paymentLocale === 'ja';
    },
  },
};
</script>

<style scoped>
.notice-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.notice-title {
  font-size: 18px;
  font-weight: 600;
}

.notice-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.notice-list li {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.42px;
  word-break: keep-all;
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.check-icon {
  color: var(--Grey-grey-900, #333);
}

.seperate-terms {
  flex-direction: column;
}

.popup {
  font-size: 16px;
  font-weight: 700;
}

.popup-text {
  color: var(--Orange-orange-500);
  font-size: 16px;
  font-weight: 700;
}

.alert-text {
  color: var(--Orange-orange-500);
  font-size: 14px;
  font-weight: 700;
}

.bold {
  font-weight: 500;
}

.pw {
  white-space: pre-wrap;
}

@media screen and (min-width: 768px) {
  .notice-wrapper {
    margin-bottom: 80px;
    gap: 16px;
  }

  .notice-title {
    display: flex;
    align-items: center;
    height: 50px;
    font-size: 24px;
  }

  .notice-list {
    gap: 4px;
  }

  .notice-list li {
    font-size: 18px;
  }

  .alert-text {
    font-size: 18px;
  }
}
</style>
